import { Page } from '@roc/feature-app-core';
import { MoveAppraisalModal, SecondAppraisalForm } from '@roc/feature-appraisals';
import { Route } from 'react-router';

const LOANS_HOME_BASE_PATH = 'loans';
const LOAN_BASE_PATH = ':loanId';

export const getMoveAppraisalRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    loans: (loanId?: string) => ({
      path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}`,
      url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}`,
      children: {
        moveAppraisal: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/move-appraisal`,
          url: `${basePath}/${LOANS_HOME_BASE_PATH}/${loanId}/move-appraisal`,
          documentTitle: `${loanId} - Move Appraisal`,
        },
      },
    }),
  };
};

export const getMoveAppraisalRoutes = (
  basePath: string,
  baseUrl: string,
  loanId: any,
  propertyId: any
) => {
  const config = getMoveAppraisalRoutesConfig(basePath, baseUrl);
  return {
    moveAppraisal: (
      <Route exact path={config.loans().children.moveAppraisal.path}>
        <Page routeDefinition={config.loans().children.moveAppraisal}>
          <MoveAppraisalModal />
        </Page>
      </Route>
    ),
  };
};
